import React from "react";
import { Layout } from "antd";
import FilterBar from "./FilterBar";
import CreditHistoryStyled from "./styled";
import TableCredit from "./TableCredit";

const { Content } = Layout;

const CreditHistory = (props) => {
  const { storeList, params, setParams, loading, resData, setResData, form } = props;

  const handleFilterChange = (filter) => {
    let { pagination } = params;
    pagination = { ...pagination, current: 1 };
    //set page to 1 when change filter
    setResData();
    setParams({ ...params, filter, pagination });
  };

  const { filter, pagination } = params;

  return (
    <CreditHistoryStyled>
      <Content
        style={{
          padding: "24px 20px 24px 20px",
          background: "white",
          borderRadius: 8,
        }}
      >
        <FilterBar value={filter} onChange={handleFilterChange} loading={loading} storeList={storeList} form={form} />
        <TableCredit
          dataSource={resData?.data}
          pagination={{ ...pagination, total: resData?.total }}
          loading={loading}
          storeList={storeList}
          form={form}
        />
      </Content>
    </CreditHistoryStyled>
  );
};

export default CreditHistory;
